import React from "react";
import "./IndustryProjects.css";

import {
  FaGraduationCap,
  FaGithub,
  FaJira,
  FaLaptopCode,
  FaHeart,
  FaCode,
  FaUsers,
  FaShieldAlt,
  FaAward
} from "react-icons/fa";

import NasscomLogo from "./NASSCOM.png";


const IndustryProjects = () => {

  return (

    <section className="industry">

      {/* =================================================
          BADGE
      ================================================= */}

      <div className="industry-badge">

        <img
          src={NasscomLogo}
          alt="PRT Academy curriculum certification"
          className="industry-badge-logo"
        />

        <span>
          Industry-Aligned Curriculum
        </span>

        <div className="industry-badge-icon">
          <FaAward />
        </div>

      </div>


      {/* =================================================
          HEADER
      ================================================= */}

      <h2 className="industry-title">
        Build Real <span>Industry Experience</span>
      </h2>


      <p className="industry-desc">
        Go beyond classroom learning with practical projects,
        modern development tools and professional workflows
        that help you build job-ready technical skills.
      </p>


      {/* =================================================
          REAL PROJECTS
      ================================================= */}

      <h3 className="industry-subTitle">
        <FaLaptopCode />
        Real-Time Projects
      </h3>


      <div className="project-grid">


        {/* SKILLZVERSE */}

        <div className="project-card">

          <div className="project-icon skill">
            <FaGraduationCap />
          </div>

          <h4>
            SkillzVerse
          </h4>

          <p>
            Work on a learning platform using React,
            Spring Boot, REST APIs, authentication
            and responsive UI development.
          </p>

        </div>


        {/* INVITWO */}

        <div className="project-card">

          <div className="project-icon invitwo">
            <FaHeart />
          </div>

          <h4>
            Invitwo
          </h4>

          <p>
            Build features for a digital invitation
            platform including templates, galleries,
            RSVP workflows and admin functionality.
          </p>

        </div>


      </div>


      {/* =================================================
          INDUSTRY TOOLS
      ================================================= */}

      <h3 className="industry-subTitle">
        Industry Tools & Workflows
      </h3>


      <div className="tool-grid">


        {/* GIT */}

        <div className="tool-card">

          <FaGithub />

          <div>

            <h4>
              Git & GitHub
            </h4>

            <p>
              Learn version control, repositories,
              branching, commits, pull requests
              and collaborative development.
            </p>

          </div>

        </div>


        {/* JIRA */}

        <div className="tool-card">

          <FaJira />

          <div>

            <h4>
              Jira
            </h4>

            <p>
              Understand task management,
              sprint planning, bug tracking
              and Agile workflows.
            </p>

          </div>

        </div>


        {/* DEVELOPMENT WORKFLOW */}

        <div className="tool-card">

          <FaLaptopCode />

          <div>

            <h4>
              Development Workflow
            </h4>

            <p>
              Practice structured development
              workflows and professional project
              collaboration.
            </p>

          </div>

        </div>


        {/* API DEVELOPMENT */}

        <div className="tool-card">

          <FaCode />

          <div>

            <h4>
              API Development
            </h4>

            <p>
              Work with APIs and modern backend
              integration concepts used in
              software projects.
            </p>

          </div>

        </div>


      </div>


      {/* =================================================
          EXPERIENCE HIGHLIGHTS
      ================================================= */}

      <div className="stats">


        <div>

          <FaLaptopCode />

          <h3>
            2+
          </h3>

          <p>
            Practical Projects
          </p>

        </div>


        <div>

          <FaGithub />

          <h3>
            Git
          </h3>

          <p>
            Version Control
          </p>

        </div>


        <div>

          <FaUsers />

          <h3>
            Agile
          </h3>

          <p>
            Project Workflow
          </p>

        </div>


        <div>

          <FaShieldAlt />

          <h3>
            Industry
          </h3>

          <p>
            Coding Practices
          </p>

        </div>


      </div>

    </section>

  );

};


export default IndustryProjects;